import type { GridCell } from '@glideapps/glide-data-grid';

import type { Row } from '../constants';

import { isMenuCell } from '../../CustomCell/Menu';
import { isDateCell } from '../../CustomCell/Date';
import { isTickerCell } from '../../CustomCell/Ticker';
import { isSharePriceCell } from '../../CustomCell/SharePrice';
import { isSharesCell } from '../../CustomCell/Shares';
import { isTotalCostCell } from '../../CustomCell/TotalCost';

import { isKindOfCustomCell } from '../../CustomCell/utils';

import type { Cache } from './ContentCache';

const getDefaultRowResponse = (): Row => ({
  ticker: null,
  date: null,
  shares: null,
  price: null,
  cost: null,
  type: null,
  currencyISO: null,
});

const extractCellValues = (cell: GridCell): Partial<Row> | undefined => {
  if (isKindOfCustomCell(cell) === false) return {};

  if (isTickerCell(cell)) {
    return {
      ticker: cell.data.value,
      currencyISO: cell.data.currencyISO,
    };
  } else if (isDateCell(cell)) {
    return {
      date: cell.data.value,
    };
  } else if (isSharesCell(cell)) {
    return {
      shares: cell.data.value,
    };
  } else if (isSharePriceCell(cell)) {
    return {
      price: cell.data.value,
    };
  } else if (isTotalCostCell(cell)) {
    return {
      cost: cell.data.value,
    };
  } else if (isMenuCell(cell)) {
    return {
      type: cell.data.value,
    };
  }
  return {};
};

export const normarliseCacheData = (cache: Cache) => {
  const columns = Array.from(cache, ([_, column]) => column);

  const rows = columns.reduce<Record<number, Row>>((a, b) => {
    for (let rowIndex = 0; rowIndex < b.length; rowIndex++) {
      const cell = b[rowIndex];

      a[rowIndex] = a[rowIndex] ?? getDefaultRowResponse();

      a[rowIndex] = {
        ...a[rowIndex],
        ...extractCellValues(cell),
      };
    }
    return a;
  }, {});

  return Object.values(rows);
};
